import { useQuery } from "@tanstack/react-query";

import { getWordSets } from "@/api/wordSets";

const DEV_ONLY_SET_IDS = new Set(["0b4b1b6a-9e7b-4f75-bf4f-641df482fba5"]);

export const wordSetsQueryKey = ["wordSets"] as const;

/** 전체 단어장 카테고리 목록 조회 */
export function useWordSetsQuery() {
  return useQuery({
    queryKey: wordSetsQueryKey,
    queryFn: getWordSets,
    select: data => (import.meta.env.DEV ? data : data.filter(set => !DEV_ONLY_SET_IDS.has(set.id))),
  });
}
